import { createStore, get, set, del, type UseStore } from 'idb-keyval';

const leverageStore: UseStore = createStore('vest-leverages', 'leverage-store');

const getKey = (address: string) => `leverages-${address.toLowerCase()}`;

export const loadLeverages = async (
  address: string,
): Promise<Record<string, number>> => {
  try {
    const data = await get<Record<string, number>>(
      getKey(address),
      leverageStore,
    );
    return data ?? {};
  } catch {
    return {};
  }
};

export const saveLeverage = async (
  address: string,
  symbol: string,
  value: number,
): Promise<void> => {
  const current = await loadLeverages(address);
  current[symbol] = value;
  await set(getKey(address), current, leverageStore);
};

export const saveLeverages = async (
  address: string,
  leverages: Record<string, number>,
): Promise<void> => {
  await set(getKey(address), leverages, leverageStore);
};

export const mergeLeverages = async (
  address: string,
  leverages: Record<string, number>,
): Promise<void> => {
  const current = await loadLeverages(address);
  await set(getKey(address), { ...current, ...leverages }, leverageStore);
};

export const clearLeverages = async (address: string): Promise<void> => {
  await del(getKey(address), leverageStore);
};
